<template>
  <SeoPage page-key="webDesignLocarno" />
</template>

<script setup>
import SeoPage from '../components/SeoPage.vue'

defineOptions({
  name: 'WebDesignLocarnoPage'
})
</script>

